module.exports = __webpack_public_path__ + "img/access_denied_image.190d4cbd.svg";